import React from "react";
import HeroSection from "../pages/HeroSection"
import ProductCarousel from "./ProductCarousel";
import MarqueeSection from "./MarqueeSection";
import ClinicallyProvenSection from "./ClinicallyProvenSection";
import AnimatedTextSection from "./AnimatedTextSection";
import LogoScroll from "./LogoScroll";
import OurStory from "./OurStory";
import SectionSkinHair from "./SectionSkinHair";
import BlogsSection from "./BlogsSection";
import DonationSection from "./DonationSection";
import Testimonials from "./Testimonials";
import CategorySection from "./CategorySection";



const Home = () => {

  return (
    <>
      <HeroSection />
      <CategorySection />
      <MarqueeSection />
      <ProductCarousel />
      <ClinicallyProvenSection />
      <Testimonials />
      <AnimatedTextSection />
      <LogoScroll />
      <OurStory />
      <SectionSkinHair />
      <BlogsSection />
      <DonationSection />
     
    </>
  );
};

export default Home;
